import demoImportSaga from './import'
import templatesSaga from './templates'
import staticEnumsSaga from './staticEnumsSaga'

const demosSagas = [demoImportSaga(), templatesSaga(), staticEnumsSaga()]

export default demosSagas
